// QR Kiosk v2 — generic Áno/Nie confirm bottom sheet (§7.3). Round-6: re-plumbed onto
// the shared KioskSheet (portaled + keyboard-safe); public API is UNCHANGED, including
// the z-index props so it can still stack ABOVE the photo carousel (overlay 1410 /
// content 1411).
import React from "react";
import useTranslation from "../../../shared/hooks/useTranslation";
import { KioskSheet } from "./KioskSheet";

export interface ConfirmSheetProps {
  open: boolean;
  onOpenChange: (next: boolean) => void;
  title: string;
  message?: React.ReactNode;
  onConfirm: () => void;
  /** Red "Áno" for destructive confirms; otherwise accent-blue. */
  danger?: boolean;
  overlayZIndex?: number;
  contentZIndex?: number;
}

export function ConfirmSheet({
  open,
  onOpenChange,
  title,
  message,
  onConfirm,
  danger,
  overlayZIndex = 40,
  contentZIndex = 41,
}: ConfirmSheetProps) {
  const { translate: tCommon } = useTranslation("common");

  const yesBg = danger ? "color-mix(in oklab, var(--red) 82%, var(--ink))" : "var(--accent)";
  const yesBorder = danger ? "1px solid color-mix(in oklab, var(--red) 55%, var(--border))" : "none";

  return (
    <KioskSheet
      open={open}
      onRequestClose={() => onOpenChange(false)}
      title={title}
      overlayZIndex={overlayZIndex}
      contentZIndex={contentZIndex}
    >
      {message && (
        <div style={{ fontSize: 13, color: "var(--muted)", marginTop: 6, lineHeight: 1.5 }}>{message}</div>
      )}
      <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
        <button
          type="button"
          onClick={() => onOpenChange(false)}
          style={{
            flex: 1,
            height: 48,
            borderRadius: 11,
            border: "1px solid var(--border)",
            background: "var(--bg)",
            color: "var(--ink-2)",
            fontFamily: "inherit",
            fontSize: 14.5,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          {tCommon("common.no")}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          style={{
            flex: 1,
            height: 48,
            borderRadius: 11,
            border: yesBorder,
            background: yesBg,
            color: "var(--tier-accent-fg)",
            fontFamily: "inherit",
            fontSize: 14.5,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          {tCommon("common.yes")}
        </button>
      </div>
    </KioskSheet>
  );
}

export default ConfirmSheet;
